
function _default(mapType, region) {
  if (mapType === 'china' && region.name === '台湾') {
    // 钓鱼岛
    region.geometries.push({
      type: 'polygon',
      exterior: [
        [123.25165252685547, 25.73527164402261],
        [123.65731445312499, 25.59527164402261],
        [123.75731445312499, 25.910734064600884],
        [123.45165252685547, 25.800734064600884],
        [123.25165252685547, 25.73527164402261]
      ],
    });
    // 赤尾屿
    region.geometries.push({
      type: 'polygon',
      exterior: [
        [124.45165252685547, 25.93527164402261],
        [124.85731445312499, 25.79527164402261],
        [124.95731445312499, 25.810734064600884],
        [124.65165252685547, 26.000734064600884],
        [124.45165252685547, 25.93527164402261]
      ],
    });
  }
}

module.exports = _default;
